import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const Popup = ({ lang }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  return (
    <Modal className="modal" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Today is Mental Health Action Day!</Modal.Title>
      </Modal.Header>
      <Modal.Body closeButton>
        From supporting a friend to exploring resources, taking action on mental
        health can be easy. Mental Health is Health is a first-of-its-kind
        resource site to help you take action for yourself, for your loved ones,
        and for your community.
      </Modal.Body>
      <Modal.Footer>
        <a
          href="https://www.mentalhealthishealth.us/"
          className="btn btn-white btn-block"
          target="_blank"
          rel="noreferrer"
        >
          Take Action
        </a>
      </Modal.Footer>
    </Modal>
  );
};
export default Popup;
